/**
 * Inline header search (FacetWP `search_search` facet uses `_search_search` GET param).
 */
import { closeLanguage } from './site-language';

const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let lastSearchToggle = null;

function setSearchExpanded(isOpen) {
	document.querySelectorAll('[data-site-search-toggle]').forEach((el) => {
		el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
	});
}

function setLeadCaretVisible(input, caret) {
	if (!caret) {
		return;
	}
	caret.classList.toggle('hidden', Boolean(input?.value?.length));
}

function openSearch(triggerEl) {
	const header = document.getElementById('site-header');
	const panel = document.querySelector('[data-site-search]');
	if (!header || !panel || document.body.classList.contains('site-search-open')) {
		return;
	}

	if (triggerEl instanceof HTMLElement) {
		lastSearchToggle = triggerEl;
	}

	if (document.body.classList.contains('offcanvas-open')) {
		document.querySelectorAll('.offcanvas-toggler').forEach((btn) => {
			btn.click();
		});
	}

	if (document.body.classList.contains('site-language-open')) {
		closeLanguage();
	}

	header.classList.add('site-search-active');
	panel.classList.remove('opacity-0', 'pointer-events-none');
	panel.classList.add('translate-x-0', 'opacity-100', 'pointer-events-auto');
	panel.setAttribute('aria-hidden', 'false');
	document.body.classList.add('site-search-open');
	setSearchExpanded(true);

	const logo = header.querySelector('.site-header-logo');
	const openBtn = header.querySelector('.site-search-open-btn');
	const closeBtn = header.querySelector('.site-search-close-btn');
	const input = panel.querySelector('[data-site-search-input]');
	const caret = panel.querySelector('[data-site-search-lead-caret]');

	logo?.classList.add('opacity-0', 'pointer-events-none');
	logo?.classList.remove('translate-x-0\!');
	logo?.setAttribute('tabindex', '-1');
	openBtn?.classList.add('hidden');
	closeBtn?.classList.remove('hidden');

	setLeadCaretVisible(input, caret);

	if (input) {
		input.removeAttribute('tabindex');
		requestAnimationFrame(() => input.focus());
	}
}

function closeSearch() {
	const header = document.getElementById('site-header');
	const panel = document.querySelector('[data-site-search]');
	if (!header || !panel || !document.body.classList.contains('site-search-open')) {
		return;
	}

	header.classList.remove('site-search-active');
	panel.classList.add('-translate-x-12', 'opacity-0', 'pointer-events-none');
	panel.classList.remove('translate-x-0', 'opacity-100', 'pointer-events-auto');
	panel.setAttribute('aria-hidden', 'true');
	document.body.classList.remove('site-search-open');
	setSearchExpanded(false);

	const input = panel.querySelector('[data-site-search-input]');
	const caret = panel.querySelector('[data-site-search-lead-caret]');
	if (input) {
		input.value = '';
		input.setAttribute('tabindex', '-1');
	}
	setLeadCaretVisible(input, caret);

	const logo = header.querySelector('.site-header-logo');
	const openBtn = header.querySelector('.site-search-open-btn');
	const closeBtn = header.querySelector('.site-search-close-btn');

	logo?.classList.remove('opacity-0', 'pointer-events-none');
	logo?.classList.add('translate-x-0\!');
	logo?.removeAttribute('tabindex');
	openBtn?.classList.remove('hidden');
	closeBtn?.classList.add('hidden');

	if (lastSearchToggle instanceof HTMLElement) {
		lastSearchToggle.focus();
		lastSearchToggle = null;
	}
}

document.querySelectorAll('[data-site-search-toggle]').forEach((btn) => {
	btn.addEventListener('click', () => {
		if (document.body.classList.contains('site-search-open')) {
			closeSearch();
		} else {
			openSearch(btn);
		}
	});
});

document.querySelectorAll('[data-site-search-close]').forEach((btn) => {
	btn.addEventListener('click', () => closeSearch());
});

document.addEventListener('input', (e) => {
	const t = e.target;
	if (t?.matches?.('[data-site-search-input]')) {
		const panel = t.closest('[data-site-search]');
		const caret = panel?.querySelector('[data-site-search-lead-caret]');
		setLeadCaretVisible(t, caret);
	}
});

document.addEventListener('DOMContentLoaded', (e) => {
	if (prefersReduced) {
		const header = document.getElementById('site-header');
		const panel = document.querySelector('[data-site-search]');
		const logo = header.querySelector('.site-header-logo');
		logo.classList.add('transition-none!');
		panel.classList.add('transition-none!');
	}
});
document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' && document.body.classList.contains('site-search-open')) {
		closeSearch();
	}
});
